<template>
    <div id="app">
        <div
            class="container"
            :class="{
                paddingBottom: $store.state.User.iphonex,
                hasTabPaddingBottom: $store.state.User.iphonex,
                iosmargin: $store.state.User.ios && isFull,
                iphonexmargin: $store.state.User.iphonex && isFull
            }"
        >
            <router-view ref="contenterbody" v-if="$route.meta.nokeepAlive" />
            <keep-alive v-else>
                <router-view ref="contenterbody" />
            </keep-alive>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex'
import { Toast, Dialog } from 'vant'
export default {
    name: 'App',
    components: {},
    data() {
        return {
            isFull: false
        }
    },
    watch: {
        $route: {
            handler(val, oldVal) {
                if (val.name == 'justLogin') {
                    this.upDataUserInfo({})
                    this.updateLoginStatus(false)
                }
                if (!this.isLogin) {
                    this.$router.push('/login')
                }
                this.versionChecking()
                if (val.name == 'justLogin' || val.name == 'registeredUser') {
                    this.isFull = false
                } else {
                    this.isFull = true
                }
            },
            deep: true //深度监听
        }
    },
    computed: {
        ...mapGetters('User', ['hasLogged', 'isTestAccount', 'userBalance', 'noviceTaskStatus']),
        ...mapState({
            userInfo: state => state.User.userInfo,
            isLogin: state => state.User.isLogin
        })
        // cache() {//页面缓存有关
        // 	return this.$store.state.Game.cachePages;
        // },
    },
    created() {
        // this.$store.commit('Game/clearCachePages');
        process.env.NODE_ENV == 'production' && !window.cordova ? this.$tools.getBrowserBevice() : null
        //ios兼容设置
        let self = this
        let ios = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
        setTimeout(() => {
            if (window.cordova && ios) {
                document.addEventListener('deviceready', onDeviceReady, false)
                function onDeviceReady() {
                    self.$store.state.User.ios = true
                    self.$store.state.User.iphonex = self.$tools.getBeviceInfo()
                    self.$store.commit('User/setDevice', {
                        ios: ios,
                        iphonex: self.$tools.getBeviceInfo()
                    })
                }
            } else {
            }
        }, 500)
        // this.getAgent();
        this.installAgent()
    },
    methods: {
        ...mapMutations('User', ['upDataUserInfo', 'updateLoginStatus']),
        goNewPeo() {
            this.$router.push({
                name: 'newtask'
            })
        },
        //ios兼容与版本更新的内容
        versionChecking() {
            if (window.chcp) {
                let self = this
                document.addEventListener('deviceready', () => {
                    let chcp = window.chcp
                    chcp.fetchUpdate((error, data) => {
                        if (error) {
                            return
                        } else {
                            Dialog.alert({
                                className: 'tips-dialogs',
                                message: '有新的内容需要更新!'
                            }).then(() => {
                                Toast.loading({
                                    duration: 0,
                                    className: 'spinner-loading',
                                    message: '更新中...',
                                    overlay: true,
                                    loadingType: 'spinner'
                                })
                                chcp.installUpdate(error => {
                                    if (error) {
                                        self.$toast('更新失败!')
                                        Toast.clear()
                                    } else {
                                        self.$toast('更新成功！')
                                        Toast.clear()
                                    }
                                })
                            })
                        }
                    })
                })
            }
        },
        getAgent() {
            setTimeout(() => {
                if (window.cordova && window.openinstall) {
                    document.addEventListener('deviceready', onDeviceReady, false)
                    function onDeviceReady() {
                        window.openinstall.registerWakeUpHandler(
                            function (data) {},
                            function (msg) {}
                        )
                    }
                }
            }, 800)
        },
        customeReporteSerch(obj, isprofitagent) {
            //客户报表-筛选数据-点击了搜索按钮,触发动作. 并传递参数
            let { begin, end, nameValue } = obj
            if (isprofitagent == 0) {
                //洗码接口
                this.$refs.contenterbody.$refs.main.customerexport &&
                    this.$refs.contenterbody.$refs.main.customerexport(1, end, begin, nameValue, 'new')
            } else {
                //负盈利接口
                this.$refs.contenterbody.$refs.main.getcustomerrpport &&
                    this.$refs.contenterbody.$refs.main.getcustomerrpport(1, nameValue, end, 'new')
            }
        },
        setChannel() {
            setTimeout(() => {
                if (window.cordova && cordova.plugins && cordova.plugins.clipboard) {
                    document.addEventListener('deviceready', onDeviceReady, false)
                    function onDeviceReady() {
                        document.addEventListener('deviceready', () => {
                            cordova.plugins.clipboard.paste(function (text) {
                                if (text.indexOf('rid=') != -1 && text.indexOf('platform=') != -1) {
                                    let arr = text.split('&')
                                    if (arr[1].split('platform=')[1] == 'jsyl' && arr[0].split('rid=')[1]) {
                                        localStorage.setItem('channel', arr[0].split('rid=')[1])
                                    }
                                }
                            })
                        })
                    }
                } else {
                }
            }, 800)
        },

        installAgent() {
            let channel = localStorage.getItem('channel')
            if (!channel) {
                this.setChannel()
            }
        }
        // checklogin() {//废弃
        // 	// 登陆信息
        // 	let _this = this;
        // 	if (_this.hasLogged && !_this.isTestAccount) {//是正式用户
        // 		if (_this.userInfo.user.target_daily_signin == 1) { //1-开启了登陆领奖
        // 			if (_this.userInfo.user.is_signin == 0) {//登陆奖励领取状态 0-未领取 - 弹出登陆奖励框
        // 				let a = {
        // 					inapp: 2,
        // 				};
        // 				_this.$api.user.checklogin(a).then(res => {
        // 					if (res.status == '240000001') {
        // 						let obj = {
        // 							user: res.data,
        // 							istester: '0', //非试完用户
        // 						};
        // 						this.$store.commit('User/upDataUserInfo', obj);
        // 						_this.showMoal(_this.userInfo.user);
        // 					}
        // 				});
        // 			}
        // 		}
        // 	}
        // },
        // showMoal(LoginData) {
        // 	this.$modal({
        // 		type: 'success',
        // 		icon: 'none',
        // 		classname: 'login-modal',
        // 		content: `<div class="trophy"></div><div class='level curren'>
        // 	尊敬的<span>VIP${LoginData.currentlevel}</span>用户，您已获得登录奖励</div><div class='level'><span class='currentWeekRights'>
        // 		${LoginData.signin_bonus}</span><span class="color">元</span></div></div><div class='level todate'>
        // 		明日登录奖励${LoginData.signin_bonus}元
        // 	</div><div class='level textlevel'> 升级至VIP${LoginData.nextlevel}每天即可领取${LoginData.nextsignin_bonus}元</div>`,
        // 	});
        // },
    }
}
</script>

<style lang="less">
@import './assets/css/reset.less';
@import './assets/css/app.less';
.van-nav-bar__content {
    height: inherit !important;
}
#app {
    .novicetask {
        position: fixed;
        bottom: 24%;
        right: 0;
        z-index: 2002;
        width: 210px;
    }
    .container {
        padding: 0;
        margin: 0;
        position: relative;
        top: 0;
        left: 0;
        width: 100%;
        height: auto;
        // overflow-y: scroll;
        overflow: visible;
        box-sizing: border-box;
        -webkit-overflow-scrolling: touch;
    }
    .paddingBottom {
        padding-bottom: 1rem;
    }
    .hasTabPaddingBottom {
        padding-bottom: 2.18rem;
    }
}
</style>
